"use client";

import React, {useEffect, useId, useState} from "react";
import Select, {components} from "react-select";
import ChevronDownIcon from "@heroicons/react/16/solid/ChevronDownIcon";


const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            {/*<ArrowDownIcon className={'w-4 h-4 text-[#000]'}/>*/}
            <ChevronDownIcon className={'w-4 h-4 text-[#000]'}/>
        </components.DropdownIndicator>
    );
};

const IndicatorSeparator = ({innerProps}) => {

    const indicatorSeparatorStyle = {
        display: 'none'
    };

    return <span style={indicatorSeparatorStyle} {...innerProps} />;
};


const NFSelect = (props) => {

    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = (v) => {
        //console.log('set select change', v);

        setSelectedOption(v);
    }

    useEffect(() => {
        //console.log('set select', props.value);
        if (props.options && props.value)
            setSelectedOption(props.options.find(opt => props.value.value ? opt.value === props.value.value : opt.value === props.value));
        else if (props?.options?.length > 0)
            setSelectedOption(props.options[0]);

    }, [JSON.stringify(props.options.map(o => o.value)), props?.value]);

    useEffect(() => {
        if (props?.onChange && selectedOption && selectedOption.value && (props.value && (props.value.value ? props.value.value !== selectedOption.value : props.value !== selectedOption.value)))
            props.onChange(selectedOption);
    }, [selectedOption]);

    let label = props.label ? props.label : undefined;

    let errors = props.errors ? [...props.errors] : [];

    const Control = (controlProps) => {

        return <components.Control {...controlProps}>
            {props.prefix && <div className={'ml-2 font-normal'}>{props.prefix}</div>}
            {controlProps.children}
        </components.Control>
    };


    return <div className={`group-input-select relative ${props?.className}`}>


        <Select options={props.options}
                id={`select_${props.name}`}
                instanceId={useId()}
                isClearable={props?.clearable ? true : false}
                components={{DropdownIndicator, IndicatorSeparator, Control, ...props?.components}}
                isSearchable={props?.search ? true : false}
                defaultValue={props?.defaultValue ? props.defaultValue : undefined}
                value={selectedOption}
                styles={{
                    control: (provided, state) => ({
                        ...provided,
                        borderColor: errors && errors.length > 0 ? 'rgb(248 113 113)' : 'rgb(209 213 219)',
                        textTransform: 'capitalize',
                        fontWeight: '500',
                        outline: '0',
                        height: '40px',
                        minHeight: '28px',
                        ':focus': {
                            outline: 'none'
                        },
                        ':active': {
                            outline: 'none'
                        },
                        cursor: 'pointer',
                        ...props?.styles?.control
                    }),
                    dropdownIndicator: (provided, state) => ({
                        ...provided,
                        ...props?.styles?.dropdownIndicator
                    }),
                    valueContainer: (provided, state) => ({
                        ...provided,
                        ...props?.styles?.valueContainer
                    }),
                }}
                onChange={handleChange}
                {...props?.extra}

        />
        {label && <label htmlFor={name}
                         className={`absolute -top-[12px] left-[6px] px-[4px] block  cursor-text text-md select-none text-[#757575] scale-[0.8] bg-white`}>
            {label}{props.required && '*'}
        </label>}
        {errors && errors.length > 0 && <>
            {errors.map((error, i) => <p key={['input', props.name, 'error', i].join('_')} className={'text-sm text-red-400'}>{error}</p>)}
        </>}
    </div>;

    //const [selectedOption, setSelectedOption] = useState(null);


}


export default NFSelect;
